import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-bg-reject-dialouge',
  templateUrl: './bg-reject-dialouge.component.html',
  styleUrls: ['./bg-reject-dialouge.component.scss']
})
export class BgRejectDialougeComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BgRejectDialougeComponent>,
     public dialog: MatDialog,
     @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

  }

  close(): void {
    this.dialogRef.close();
  }

}
